const styles = {
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tableContainer: {
    border: "1px solid",
    borderColor: "#EAECF0",
    borderRadius: "8px",
    marginLeft: "2rem",
    marginRight: "2rem",
  },
  inputPropsIcon: {
    height: "1rem",
    width: "1rem",
  },
  actionItemGrid: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    alignItems: "center",
  },
  actionIcon: {
    height: "1.5rem",
    width: "1.5rem",
  },
  statusText: (color: string) => ({
    color: color,
    fontWeight: 500,
    lineHeight: "1.125rem",
    fontSize: "0.75rem",
  }),
  actionText: (color: string) => ({
    color: color,
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  }),

  formContainer: { display: "grid", gap: "0.5rem", paddingTop: "1rem" },
  subHeading: {
    fontWeight: 600,
    color: "#334155",
    lineHeight: "2rem",
    fontSize: "1.125rem",
  },
  filterDrawer: {
    "& .css-1160xiw-MuiPaper-root-MuiDrawer-paper ": {
    height: "fit-content !important",
    top: "11rem",
    right: "2rem",
    position: "absolute",
    maxWidth: "38rem"
  }
  },
};

export default styles;
